import React from "react";
import "./Cards.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, NavLink } from "react-router-dom";
import MediaCarousel from "./pages/MediaCarousel";

function Cards() {
  return (
    <div className="cards">
      {/* <h2 tabIndex={0}><span>Tech Expressway</span> Learning Journey</h2> */}
      <h2 tabIndex={0}>
        <span> Entry Level</span> Learning Journey
      </h2>
      <div className="tiles-box-home">
        <MediaCarousel/>
        {/* <figure> */}
          {/* <img src="/images/TechExpresswayLearningJourney-all-new.png" alt="Tech Expressway Learning Journey" className="all-journey-img"/>
                <img src="/images/JobRedinessModles-new-latestone.png" alt="Tech Expressway Learning Journey" className="all-journey-img"/> */}
          {/* <img
            src="/images/entrylevel.png"
            alt="Tech Expressway Learning Journey"
            className="all-journey-img"
          />
          {/*  <img src="/images/LandingPage/LearningJourney.png" alt="Tech Expressway Learning Journey" className="all-journey-img"/> */}
        {/* </figure>  */}


        {/* <ul className="tiles-row">
                    <li className="tiles-list">
                        <Link className="tiles-list-link" to="/foundation-component" target="_blank">
                            <figure className="tiles-list-pic"><img src="/images/techstary-icon.png" alt="image" className="tiles-list-img"/>FOUNDATION</figure>
                        </Link></li>
                    <li className="tiles-list">
                        <Link className="tiles-list-link" to="/home">
                            <figure className="tiles-list-pic"><img src="/images/techify-icon.png" alt="image" className="tiles-list-img"/>ORIENTATION</figure>
                        </Link></li>
                    <li className="tiles-list">
                        <Link className="tiles-list-link" to="/job-readiness" target="_blank">
                            <figure className="tiles-list-pic"><img src="/images/techgenics-icon.png" alt="image" className="tiles-list-img"/>JOB READINESS</figure>
                        </Link></li>
                    <li className="tiles-list">
                        <a href="https://atci.techleap.accenture.com" target="_blank" className="tiles-list-link">
                            <figure className="tiles-list-pic"><img src="/images/techleap-icon.png" alt="image" className="tiles-list-img"/>SPECIALIZATION</figure>
                        </a></li>
                </ul> */}
      </div>
      <div className="cards_container">
        <div className="cards_wrapper">
          <ul className="cards_items">
            <li className="cards_item">
              <NavLink
                to="/foundation-component"
                target="_blank"
                className="cards_item_link"
              >
                <figure className="cards_item_picwrap">
                  <img
                    src="/images/foundation-image.jpg"
                    alt=""
                    className="cards_item_img"
                  />
                  <div className="card-item-cont">
                    <h3>FOUNDATION</h3>
                    {/* <p>(Level 1)</p> */}
                  </div>
                </figure>
              </NavLink>
            </li>
            <li className="cards_item">
              <NavLink
                to="/job-readiness"
                target="_blank"
                className="cards_item_link"
              >
                <figure className="cards_item_picwrap">
                  <img
                    src="/images/TechGenics.png"
                    alt=""
                    className="cards_item_img"
                  />
                  <div className="card-item-cont">
                    <h3>JOB READINESS</h3>
                    {/* <p>(Level 2)</p> */}
                  </div>
                </figure>
              </NavLink>
            </li>
            <li className="cards_item">
              <a
                href="https://atci.techleap.accenture.com"
                target="_blank"
                className="cards_item_link"
              >
                <figure className="cards_item_picwrap">
                  <img
                    src="/images/TechLeap.png"
                    alt=""
                    className="cards_item_img"
                  />
                  <div className="card-item-cont">
                    <h3>SPECIALIZATION</h3>
                    {/* <p>(Level 3)</p> */}
                  </div>
                </figure>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
